import { ClientEnum } from '../enums/app.enum';
import { PageActionCodeType } from '../types/app.type';
import { IInsurersDetails } from './insurer.interface';
import { IPopiaConsentMessage } from './popia.interface';

export interface IAppSettings {
  add_contents_to_quote?: boolean;
  show_need_analysis?: boolean;
  motor_group_key: string;
  motor_group_url: string;
  motor_group_details: boolean;
  fsb_number: string;
  fsb_certification_url: string;
  terms_url: string;
  e_natis_url: string;
  default_insurer_id?: string;
  brolink_assist_amount?: number;
  referral_amount?: number;
  refer_a_friend_enabled?: boolean;
  validate_email_for_spam_enabled?: boolean;
  referral_code_prefix: string;
  list_brokers_on_registration?: boolean;
  search_broker_with_code: boolean;
  up_to_number_of_quotes?: number;
  broker_search_prefix?: string;
  broker_search_default_code?: string;
  consent_enabled?: boolean;
  debug_user: string;
  broker_on_behalf_of_enabled?: boolean;
  app_download_url: string;
  download_qr_code_image_url: string;
  popi_consent: IPopiaConsentMessage;
  ai_object_map_enabled?: boolean;
  ai_question_map_enabled?: boolean;
  ai_schedule_interpreter_enabled?: boolean;
  ai_user_access_list?: Array<string>;
  maintenance_mode?: boolean;
  assets_in_app?: IAssetsInApp;
  decommissioning_notice?: boolean;
  maintenance_period_notification?: boolean;
  maintenance_period_start_date?: string;
  maintenance_period_end_date?: string;
  add_emergency_benefits?: boolean;
  premia_collection_date_show?: boolean;
}

export interface IAssetsInApp {
  all_risk: boolean;
  buildings: boolean;
  caravans: boolean;
  contents: boolean;
  motorcycles: boolean;
  specified_items: boolean;
  vehicles: boolean;
}

export interface IAppClientSpecificTextSettings {
  control_in_sentences: string;
  added_benefits_text: string;
}
export interface IAppCredentials {
  firebase_credentials: any;
  ctrl_api_url: string;
  mix_panel_key?: string;
  intercom_app_id?: string;
  firebase_functions_url?: string;
  application?: {
    login_heading: string;
    login_heading_color: string;
  };
}

export interface IClassObject {
  message: string;
  success: boolean;
}
export interface IClientDetails {
  display_name_full: string;
  display_name_short: string;
}

export interface IVersion {
  version: string;
}
export interface IAppClientDetail {
  domain: string;
  display_name: string;
  display_name_full: string;
  client_name_key: string;
  version: string;
  enum_name: ClientEnum;
  static_wallet_page_image: boolean;
  static_refer_friend_page_image: boolean;
  show_cover_start_date: boolean;
  static_landing: boolean;
  client_type: string;
  show_recommended: boolean;
  can_download_app: boolean;
  otp_alt_call_options: boolean;
  app_client_specific_text_settings: {
    added_benefits_text: string;
    quote_complete_header_text: string;
    quote_complete_button_text: string;
  };
  app_client_specific_colours: {
    quote_percentage_circle_recommended_color: string;
    quote_percentage_circle_not_recommended_color_svga_element: string;
    titleColor: string; // Added this missing property
  };
  landing_videos: {
    step_one_video_url: string;
    step_two_video_url: string;
    step_three_video_url: string;
    step_four_video_url: string;
  };
  insurer_contact_details: Array<IInsurersDetails>;
}

export interface IPageAction {
  actionCode: PageActionCodeType;
  parameters?: any;
}

export interface IInsurerContactDetails {
  number: string;
  name: string;
}

export interface IBrokerPortalCredentials {
  production: boolean;
  title: string;
  api: string;
  firebaseKey: string;
  intercomWorkspace: string;
  primaryColor: string;
  logo: string;
  trackingId: string;
  webAppUrl: string;
  brokerageDetails?: Array<string>;
}
